<div id="wrap">
    <header class="header">
        <div class="header_inner">
            <h1 class="header_logo">
                <a href="" class="logo"><img src="/assets/images/web/logo/logo_348.png" alt="OASIS BUDDY" /></a>
            </h1>
            <span class="util_right" *ngIf="!user" >
                <button type="button" (click)="openGuideWindow()" class="btn_box">이용가이드</button>
                <a (click)="moveJoin()" class="btn_join"><b>회원가입</b></a>
                <a href="https://www.oasis.co.kr" target="_blank" class="btn_oasis ico_blank">오아시스마켓</a>
            </span>
            <span class="util_right" *ngIf="user">
                <button type="button" (click)="openGuideWindow()" class="btn_box">이용가이드</button>
                <a routerLink="/mypage/main" class="btn_mypage" *ngIf="!user.isAdmin"><b>MY page</b></a>
                <a class="btn_logout" (click)="logout()"><b>LOGOUT</b></a>
            </span>
        </div>
    </header>

    <div id="content">
        <div id="skip_anchor" class="content page_terms">
            <div [innerHTML]="termsHtml"></div>
            <div class="select mt-40">
                <select class="select_current" [(ngModel)]="otherVersion" (change)="changeVersion()">
                    <option value="">이전 약관 보기</option>
                    <option *ngFor="let item of list" [value]="item.version">이용약관 v{{item.version}} ({{item.regDate}})</option>
                </select>
            </div>
        </div>
    </div>

    <footer class="footer">
        <app-footer></app-footer>
    </footer>
</div>
